import App from './App';

if (document.readyState !== 'complete' || document.readyState !== 'interactive') {
    document.addEventListener('DOMContentLoaded', () => window.App = new App(document.body, {}));
} else {
    window.App = new App(document.body, {});
}



// WEBPACK FOOTER //
// ./source/_assets/js/main.js